<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc">
<h1>Table of Contents</h1>
<ol>
<li id="level1-titlepage">
<span href="#/titlepage" title="Link target outside of Sample">Title Page</span>
</li>
<li id="level1-toc">
<a href="#/toc">Table of Contents</a>
</li>
<li id="level1-front3">
<a href="#/front01">Copyright</a>
</li>
<li id="level1-front4">
<a href="#/front02">Dedications</a>
</li>
<li id="level1-front5">
<a href="#/front03">Epigraph</a>
</li>
<li id="level1-front6">
<a href="#/front04">Preface</a>
</li>
<li id="level1-front7">
<a href="#/front05">Foreword by Tony La Russa</a>
</li>
<li id="level1-front8">
<a href="#/front06">Prologue</a>
</li>
<li id="c001">
<a href="#/c001">GAME ONE</a>
</li>
<li id="c01">
<a href="#/c01">Fear Factor</a>
</li>
<li id="c02">
<span href="#/c02" title="Link target outside of Sample">Locked In</span>
</li>
<li id="c03">
<span href="#/c03" title="Link target outside of Sample">“I’m Gonna Kill You!”</span>
</li>
<li id="c04">
<span href="#/c04" title="Link target outside of Sample">The Peeker</span>
</li>
<li id="c05">
<span href="#/c05" title="Link target outside of Sample">The Pitcher’s Tale</span>
</li>
<li id="c06">
<span href="#/c06" title="Link target outside of Sample">Praying for Change</span>
</li>
<li id="c002">
<span href="#/c002" title="Link target outside of Sample">GAME TWO</span>
</li>
<li id="c07">
<span href="#/c07" title="Link target outside of Sample">Gonzalez Must Pay</span>
</li>
<li id="c08">
<span href="#/c08" title="Link target outside of Sample">Light My Fire</span>
</li>
<li id="c09">
<span href="#/c09" title="Link target outside of Sample">Whodunit</span>
</li>
<li id="c10">
<span href="#/c10" title="Link target outside of Sample">Being There</span>
</li>
<li id="c11">
<span href="#/c11" title="Link target outside of Sample">Under Pressure</span>
</li>
<li id="c003">
<span href="#/c003" title="Link target outside of Sample">GAME THREE</span>
</li>
<li id="c12">
<span href="#/c12" title="Link target outside of Sample">D.K.</span>
</li>
<li id="c13">
<span href="#/c13" title="Link target outside of Sample">Thing of Beauty</span>
</li>
<li id="c14">
<span href="#/c14" title="Link target outside of Sample">Kiss My Ass</span>
</li>
<li id="c15">
<span href="#/c15" title="Link target outside of Sample">Three Nights in August</span>
</li>
<li id="level1-back27">
<span href="#/back01" title="Link target outside of Sample">Epilogue</span>
</li>
<li id="level1-back28">
<span href="#/back02" title="Link target outside of Sample">Postscript</span>
</li>
<li id="level1-back29">
<span href="#/back03" title="Link target outside of Sample">A Note on Sources</span>
</li>
<li id="level1-back30">
<span href="#/back04" title="Link target outside of Sample">Acknowledgments</span>
</li>
<li id="level1-back31">
<span href="#/back05" title="Link target outside of Sample">Index</span>
</li>
<li id="level1-back32">
<span href="#/back06" title="Link target outside of Sample">About the Author</span>
</li>
<li id="level1-footnotes">
<span href="#/footnotes" title="Link target outside of Sample">Footnotes</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?456f73ea